import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { AppComponent } from './app.component';
import { NavbarComponent } from './navbar/navbar.component';
import { AppRoutingModule } from './app.routing';
import { HomeModule } from './home/home.module';
import { AboutModule } from './about/about.module';
import { OfferModule } from './offer/offer.module';
import { FooterComponent } from './footer/footer.component';
import { PressComponent } from './press/press.component';

@NgModule({
  declarations: [
    AppComponent,
    NavbarComponent,
    FooterComponent,
    PressComponent,
  ],
  imports: [
    BrowserModule,
    RouterModule,
    AppRoutingModule,
    HomeModule,
    AboutModule,
    OfferModule
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
